import React from 'react';

export const ProfileIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="16"
    viewBox="0 0 13 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M17703.5,1158.52c2.4,0,3.3-2.37,3.5-4.32,0.3-2.39-.9-4.2-3.5-4.2s-3.8,1.81-3.5,4.2C17700.2,1156.15,17701.1,1158.52,17703.5,1158.52Zm6.5,5.65a8.662,8.662,0,0,0-.3-2.26c-0.1-.9-0.3-2.22-1.1-2.81a8.328,8.328,0,0,0-1.6-.66,3.313,3.313,0,0,1-.7-0.31,3.867,3.867,0,0,1-5.6,0,3.313,3.313,0,0,1-.7.31,8.328,8.328,0,0,0-1.6.66c-0.8.59-1,1.91-1.1,2.81a8.662,8.662,0,0,0-.3,2.26c0,0.58.3,0.66,0.8,0.84a11.438,11.438,0,0,0,1.9.52,15.6,15.6,0,0,0,7.6,0,11.438,11.438,0,0,0,1.9-.52C17709.7,1164.83,17710,1164.75,17710,1164.17Z"
      transform="translate(-17697 -1150)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/profile-icon.js